<mat-form-field appearance="fill" class="full-width m-autocomplete">
  <input matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [matAutocompleteConnectedTo]="panelOrigin"
    [readonly]="isReadOnly"
    [placeholder]="placeholder"
    aria-label="To"
    (focus)="onFocus($event)"
    (blur)="onBlur()">

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayAirport" [panelWidth]="panelWidth" (optionSelected)="onSelection($event)">
    @if ((citiesOptions$ | async); as groups) {
      @if (groups.length > 0) {
        <div class="ac-section-label">Suggestions</div>
      }
      @for (group of groups; track group.label) {
        <mat-option class="ac-option" [value]="group.primary">
          <div class="ac-row">
            <span class="ac-code">{{ group.primary.iata }}</span>
            <div class="ac-info">
              <p class="ac-name">{{ group.label }}</p>
              <p class="ac-meta">{{ group.primary.name }}</p>
            </div>
          </div>
        </mat-option>
        @if (group.others.length > 0) {
          <div class="ac-nearby-label">
            {{ group.others.length }} more airport{{ group.others.length > 1 ? 's' : '' }} in {{ group.city }}
          </div>
          @for (airport of group.others; track airport.iata) {
            <mat-option class="ac-option ac-option-nested" [value]="airport">
              <div class="ac-row">
                <span class="ac-branch" aria-hidden="true">&#8627;</span>
                <span class="ac-code">{{ airport.iata }}</span>
                <div class="ac-info">
                  <p class="ac-name">{{ airport.name }}</p>
                  <p class="ac-meta">{{ airport.city }}, {{ airport.country }}</p>
                </div>
              </div>
            </mat-option>
          }
        }
      }
    }

    @if (!isLoadingKiwi) {
      @if ((recentSearches$ | async)?.length > 0) {
        <div class="ac-section-label">Recent Searches</div>
      }
      @for (option of recentSearches$ | async; track option) {
        <mat-option class="ac-option" [value]="option">
          <div class="ac-row">
            <span class="ac-code">{{ option.iata }}</span>
            <div class="ac-info">
              <p class="ac-name">{{ option.name }}</p>
              <p class="ac-meta">{{ option.city }}, {{ option.country }}</p>
            </div>
          </div>
        </mat-option>
      }
    }



      </mat-autocomplete>
    </mat-form-field>

    @if (isLoadingKiwi) {
      <div class="loading-indicator">
        <mat-progress-bar mode="query"></mat-progress-bar>
      </div>
    }
